<template>
  <RevContainer>
    <RevBreadcrumbs
      :ariaLabel="i18n(translations.breadcrumb)"
      :breads="mobileRoutes"
      class="-ml-24 block md:hidden"
      data-qa="breadcrumb-mweb"
    />

    <RevBreadcrumbs
      :ariaLabel="i18n(translations.breadcrumb)"
      :breads="desktopRoutes"
      class="hidden md:block"
      data-qa="breadcrumb-desktop"
    />
  </RevContainer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevBreadcrumbs } from '@ds/components/Breadcrumbs'
import type { Bread } from '@ds/components/Breadcrumbs/Breadcrumbs.vue'
import { RevContainer } from '@ds/components/Container'

import { useRouteLocationWithLocale } from '~/composables/useRouteLocationWithLocale'
import { useMyOrdersRouteName } from '~/scopes/customer-care/common/composables/useMyOrdersRouteName'
import { CUSTOMER_CARE } from '~/scopes/customer-care/route-names'

import translations from './Navigation.translations'

const i18n = useI18n()
const resolveLocalizedRoute = useRouteLocationWithLocale()
const myOrdersRouteName = useMyOrdersRouteName()

const desktopRoutes: Array<Bread> = [
  {
    link: resolveLocalizedRoute({ name: myOrdersRouteName.value }),
    title: i18n(translations.myOrders),
  },
  {
    link: resolveLocalizedRoute({
      name: CUSTOMER_CARE.RESOLUTION.RESOLUTION_STRAIGHT_REFUND_CONFIRMATION,
    }),
    title: i18n(translations.refundRequest),
  },
]

const mobileRoutes: Array<Bread> = [
  {
    link: resolveLocalizedRoute({ name: myOrdersRouteName.value }),
    title: i18n(translations.myOrders),
  },
  {
    link: resolveLocalizedRoute({
      name: CUSTOMER_CARE.RESOLUTION.RESOLUTION_STRAIGHT_REFUND_CONFIRMATION,
    }),
    title: i18n(translations.refundRequest),
  },
]
</script>
